import React from 'react';
import { Paper, Button, Typography, Box, CircularProgress } from '@mui/material';
import { CheckCircle as CheckCircleIcon, Close as CloseIcon } from '@mui/icons-material';

interface ConfirmationCardProps {
  summary: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading: 'confirm' | 'cancel' | null;
  disabled: boolean;
}

export const ConfirmationCard: React.FC<ConfirmationCardProps> = ({
  summary,
  onConfirm,
  onCancel,
  isLoading,
  disabled,
}) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        mt: 1.5,
        mb: 1.5,
        borderRadius: '12px',
        borderColor: 'rgba(0, 0, 0, 0.12)',
        backgroundColor: '#FFFFFF',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 600,
          color: '#1A1A1A',
          mb: 2,
          fontSize: '13.5px',
          lineHeight: 1.4,
        }}
      >
        {summary}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1.5, justifyContent: 'flex-end' }}>
        <Button
          variant="outlined"
          color="error"
          size="small"
          onClick={onCancel}
          disabled={disabled}
          startIcon={
            isLoading === 'cancel' ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <CloseIcon sx={{ fontSize: 16 }} />
            )
          }
          sx={{
            textTransform: 'none',
            borderRadius: '8px',
            px: 2,
            fontSize: '12.5px',
            borderColor: 'rgba(211, 47, 47, 0.5)',
            '&:hover': {
              borderColor: 'rgb(211, 47, 47)',
              backgroundColor: 'rgba(211, 47, 47, 0.04)',
            },
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={onConfirm}
          disabled={disabled}
          startIcon={
            isLoading === 'confirm' ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <CheckCircleIcon sx={{ fontSize: 16 }} />
            )
          }
          sx={{
            textTransform: 'none',
            borderRadius: '8px',
            px: 2,
            fontSize: '12.5px',
            backgroundColor: '#111111',
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: '#222222',
            },
          }}
        >
          Confirm
        </Button>
      </Box>
    </Paper>
  );
};
